import {
  PaletteMode,
  SimplePaletteColorOptions,
  ThemeOptions,
} from '@mui/material';
import { useMemo } from 'react';
import DarkPalette from './DarkPalette';
import LightPalette from './LightPalette';

const Theme = (paletteMode: PaletteMode): ThemeOptions => {
  const palette = useMemo(
    () => (paletteMode == 'light' ? LightPalette : DarkPalette),
    [paletteMode]
  );

  return {
    palette: palette,
    components: {
      MuiFormControl: {
        styleOverrides: {
          root: {
            zIndex: 0,
          },
        },
      },
      MuiAlert: {
        styleOverrides: {
          filledSuccess: {
            backgroundColor:
              (palette.success as SimplePaletteColorOptions | undefined)
                ?.main ?? undefined,
            color:
              (palette.success as SimplePaletteColorOptions | undefined)
                ?.contrastText ?? undefined,
          },
          filledError: {
            backgroundColor:
              (palette.error as SimplePaletteColorOptions | undefined)?.main ??
              undefined,
            color:
              (palette.error as SimplePaletteColorOptions | undefined)
                ?.contrastText ?? undefined,
          },
          filledWarning: {
            backgroundColor:
              (palette.warning as SimplePaletteColorOptions | undefined)
                ?.main ?? undefined,
            color:
              (palette.warning as SimplePaletteColorOptions | undefined)
                ?.contrastText ?? undefined,
          },
          filledInfo: {
            backgroundColor:
              (palette.info as SimplePaletteColorOptions | undefined)?.main ??
              undefined,
            color:
              (palette.info as SimplePaletteColorOptions | undefined)
                ?.contrastText ?? undefined,
          },
        },
      },
    },
    typography: {
      fontFamily: 'system-ui',
      button: {
        textTransform: 'none',
        fontWeight: '500',
      },
    },
  };
};

export default Theme;
